import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { cn } from '../../utils/cn';
import type { MiniCartButtonProps } from './mini-cart-button.types';
import { Button } from '../../atoms/button';
import { Text } from '../../atoms/text';

import styles from './mini-cart-button.module.css';

const MiniCartButton: React.FC<MiniCartButtonProps> = ({
    itemCount = 0,
    labelProps,
    onClick,
    className,
    testID = 'mini-cart-button',
    iconColor,
    icon,
    ...restProps
}) => (
    <Button
        aria-label={`Shopping cart${itemCount > 0 ? `, ${itemCount} item${itemCount > 1 ? 's' : ''}` : ''}`}
        {...restProps}
        onClick={onClick}
        className={cn(styles.container, className)}
        data-testid={testID}
    >
        {icon ?? <ShoppingCart color={iconColor} className={styles.icon} />}
        {itemCount > 0 && (
            <Text {...labelProps} className={cn(styles.label, labelProps?.className)}>
                {itemCount > 99 ? '99+' : itemCount}
            </Text>
        )}
    </Button>
);

export default MiniCartButton;
